import InnerBanner from "../Components/InnerBanner/InnerBanner";
import Booking from "../Components/Booking/Booking";
import RecentBlog from "../Components/RecentBlog/RecentBlog";
import MultiContent from "../Components/MultiContent/MultiContent";
import {useState} from "react";
import {Link} from "react-router-dom";

function About() {
    const essenceData = [
        {
            id: 1,
            imageSrc: '/images/essence1.webp',
            number: '1',
            title: 'Expertise',
            content: 'Skill Bridge. boasts a team of industry-seasoned DevOps professionals who have traversed the dynamic tech terrain. Their firsthand experiences provide invaluable insights that go beyond theoretical knowledge, giving our programs a distinct edge.',
        },
        {
            id: 2,
            imageSrc: '/images/essence2.webp',
            number: '2',
            title: 'Innovation',
            content: 'Skill Bridge. boasts a team of industry-seasoned DevOps professionals who have traversed the dynamic tech terrain. Their firsthand experiences provide invaluable insights that go beyond theoretical knowledge, giving our programs a distinct edge.',
        },
        {
            id: 3,
            imageSrc: '/images/essence3.webp',
            number: '3',
            title: 'Commitment',
            content: 'Skill Bridge. boasts a team of industry-seasoned DevOps professionals who have traversed the dynamic tech terrain. Their firsthand experiences provide invaluable insights that go beyond theoretical knowledge, giving our programs a distinct edge.',
        },
        {
            id: 4,
            imageSrc: '/images/essence4.webp',
            number: '4',
            title: 'Our Approach',
            content: 'Skill Bridge. boasts a team of industry-seasoned DevOps professionals who have traversed the dynamic tech terrain. Their firsthand experiences provide invaluable insights that go beyond theoretical knowledge, giving our programs a distinct edge.',
        },
    ];

    const [activeIndex, setActiveIndex] = useState(null);

    const handleClick = (index) => {
        setActiveIndex(index === activeIndex ? null : index);
    };

    return (
        <>
            <InnerBanner
                img_url='aboutBanner.webp'
                heading='About Us'
            />
            <MultiContent
                left_img
                img_url="about1.webp"
                tag="Who we are?"
                topHeading
                heading="Skill Bridge"
                description={['\n' +
                '                                Skill Bridge. stands at the forefront of innovation, dedicated to narrowing the gap\n' +
                '                                between aspiring DevOps engineers and the ever-evolving technology landscape.\n' +
                '                            ', '\n' +
                '                                Our commitment is unwavering, and our mission is clear: to reshape the way individuals\n' +
                '                                acquire and apply DevOps skills, transforming them into proficient professionals who\n' +
                '                                empower businesses with top-tier talent.\n' +
                '                            ']}
            />
            <MultiContent
                right_img
                img_url="about2.webp"
                tag="How we work?"
                topHeading
                heading="Our Company in a Nutshell"
                descClass="med"
                description={[
                    '\n' +
                    '                                Skill Bridge. is not your typical startup; we are pioneers with a vision that extends\n' +
                    '                                far beyond the horizon. Our core focus lies in training and employing aspiring DevOps\n' +
                    '                                engineers, a niche where the importance of bridging the talent gap cannot be overstated.\n' +
                    '                                DevOps is the linchpin in enhancing collaboration, expediting software development, and\n' +
                    '                                ensuring the seamless integration of complex systems.\n' +
                    '                            '
                ]}
            />
            <section className="essenceSec">
                <div className="container-lg">
                    <div className="row">
                        <div className="col-12">
                            <div className="title center">
                                <h2 className="secHeading" data-aos='fade-up'>
                                    The Essence Of Skill Bridge
                                </h2>
                                <p data-aos='fade-up' data-aos-delay='100'>
                                    We are built on a sturdy foundation comprising three crucial pillars:
                                </p>
                            </div>
                        </div>
                        {essenceData.map((essence, index) => (
                            <div className="col-md-3 col-sm-6" key={essence.id}>
                                <div className={index === activeIndex ? 'essenceCard active' : 'essenceCard'} data-aos='fade-right'>
                                    <div className="head">
                                        <figure>
                                            <img src={process.env.PUBLIC_URL + essence.imageSrc} alt=""/>
                                        </figure>
                                        <span>{essence.number}</span>
                                    </div>
                                    <h6 className="title">{essence.title}</h6>
                                    <p className="content">{essence.content}</p>
                                    <Link onClick={() => handleClick(index)} className="learnBtn">
                                        <span>{index === activeIndex ? 'View Less' : 'Learn More'}</span>
                                        <i className={index === activeIndex ? 'fas fa-chevron-up' : 'fas fa-chevron-right'} />
                                    </Link>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </section>
            <Booking/>
            <RecentBlog/>
        </>
    )
}

export default About